import { ColumnDef } from '@tanstack/react-table';
import i18n from 'i18next';

import { BlueCheckIcon as CheckIcon } from '@/resources';
import { TableData } from '@/types';

export const getPlaylistColumns: (downloadedIds?: Set<number>) => ColumnDef<TableData>[] = (
  downloadedIds
) => [
  {
    id: 'name',
    accessorKey: 'name',
    header: i18n.t('name', { ns: 'common' }),
    cell: (info) => {
      const name = info.getValue() as string;
      const id = (info.row.original as { id: number }).id;
      const isDownloaded = downloadedIds?.has(id);
      return (
        <span className='flex items-center gap-2'>
          {name}
          {isDownloaded && (
            <>
              <span className='hidden h-[25px] items-center rounded-full bg-second-accent-light-green px-1.5 py-0.5 text-2xs font-medium !text-second-accent-green md:inline-flex'>
                <>
                  <CheckIcon className='mr-1 size-3 !text-second-accent-green' />
                  {i18n.t('offline', { ns: 'common' })}
                </>
              </span>
              <div className={'size-2 rounded-full bg-second-accent-light-green md:hidden'} />
            </>
          )}
        </span>
      );
    }
  },
  {
    id: 'description',
    accessorKey: 'description',
    header: i18n.t('description', { ns: 'common' })
  },
  {
    id: 'organizationName',
    accessorKey: 'organizationName',
    header: i18n.t('organization', { ns: 'common' })
  },
  {
    id: 'noOfAssets',
    accessorKey: 'noOfAssets',
    header: i18n.t('noOfAssets', { ns: 'common' })
  },
  {
    id: 'totalDuration',
    accessorKey: 'totalDuration',
    header: i18n.t('playlistDuration', { ns: 'common' }),
    enableSorting: true
  }
];

export const getDevicePlaylistsColumns: () => ColumnDef<TableData>[] = () => [
  {
    id: 'name',
    accessorKey: 'name',
    header: i18n.t('name', { ns: 'common' })
  },
  {
    id: 'noOfAssets',
    accessorKey: 'noOfAssets',
    header: i18n.t('noOfAssets', { ns: 'common' })
  },
  {
    id: 'totalDuration',
    accessorKey: 'totalDuration',
    header: i18n.t('playlistDuration', { ns: 'common' })
  }
];
